import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import SliderWrapper from 'jd-library/SliderWrapper';
import MoreMenu from 'jd-library/MoreMenu';
import Tag from 'jd-library/Tag';
import Button from 'jd-library/Button';
import AnimateButton from 'jd-library/AnimateButton';
import withRipple from 'jd-library/withRipple';
import historyHandler from 'jd-library/historyHandler';
import {
    getVideoLibraryData,
    toggleLibrarySlider,
    selectVideo,
    deleteVideo
} from "../../actions/videoLibrary";
import {
	onFileSelUpload
} from "../../common/productImageUtils";
import { deleteProductVideo, getListingData, updateProductMedia } from '../../actions/products';
import FileSelector from "../../common/FileSelector";
import style from './video-listing.scss';
import VideoPlayerWrapper from '../../common/Video/VideoPlayerWrapper';
import VideoPlayerSlider from './VideoPlayerSlider';
import {
	toggleUploadOptions
} from '../../actions/upload-options';
import useOnScroll from 'jd-library/useOnScroll';
import { toastMessageActions } from 'jd-library';

const VideoListing = props => {
    const [activeEl, setActiveEl] = useState(null);
    const [openPlayer, togglePlayer] = useState(false);
    const [playerData, setPlayerData] = useState({});
    const [scrollEl, setScrollEl] = useState(null);
    const [scrolled, setScroll] = useState(false);
    const history = useHistory();
	const fileSelector = React.useRef(null);

    useOnScroll({
		callback : (e,scrollObj) => {
			if(scrollObj.currScroll.scrollTop){
				setScroll(true);
			}else{
			 	setScroll(false)
			}
		},
		element : !scrollEl ? null : scrollEl,
		deps: [scrollEl]
	})

    const list = [{
        label: 'Select',
        onClick: () => {
            onVideoSelect();
        }
    }, {
        label: 'Delete',
        onClick: () => {
            let obj = {
                videoId: activeEl
            }
            props.deleteVideo(obj);
            props.getListingData({keepAddProd: true})
        }
    }];

    const openPlayerSlider = (index) => {
        setActiveEl(index);
        setPlayerData({...props.videoLibrary.videos[index],id: index});
        togglePlayer(true);
    }

    const onVideoSelect = (videoId) => {
        if(props.videoUpload.videos[videoId]?.uploading && !props.videoUpload.videos[videoId]?.uploaded) {
            props.showToast({
                showToastMessage: true,
                message: 'Video is still uploading. Please wait or select another video',
                duration: 3000,
                type: 'error'
            })
            return;
        }
        let obj = {
            videoId: videoId || activeEl,
            productId: props.videoLibrary.productUnderEdit,
            ignoreSave: props.videoLibrary.ignoreSave,
            isAddEditProduct: props.videoLibrary.isAddEditProduct,
            isEnrchProductPage: props.videoLibrary.isEnrchProductPage,
            isAddEditProductOmni: props.videoLibrary.isAddEditProductOmni
        }
        obj.videoId = Number(obj.videoId);
        if(props.videoLibrary.onFileUpload){
            props.videoLibrary.onFileUpload({
                forVideo: true,
                videoId,
                from: 'Videogallery',
                productId: props.videoLibrary.productUnderEdit,
                imageUrl: {...props.videoLibrary.videos[obj.videoId] , videoId},
            })
        }
         if(props.videoLibrary.fromViewImageSlider){
            window.history.back();
            return;
        }
        let reviewStatus = "";
		let user = props.session.user || {};
		user = user.loggedUser || {};
		if(user.userType == "JDEMPLOYEE") {
			reviewStatus = "APPROVAL_PENDING";
		}
        props.deleteProductVideo({
			productId: obj.productId,
			videoId,
			reviewStatus,
			ignoreSave: obj.ignoreSave,
			isAddEditPage: obj.isAddEditProduct,
			undoInfo: {
				type: 'video',
				data: {
					videoId
				},
				productId: obj.productId
			}
		});
        props.selectVideo(obj);
        window.history.back();
    }

    const onChange = (e) => {
        let obj = {...props};
        obj.variantId = props.videoLibrary.variantUnderEdit;
        obj.forVideo = true;
        onFileSelUpload(e, obj);
        window.history.back();
    }

    const uploadVideo = (e, position = 'top') => {
        props.toggleUploadOptions({
            show: true,
            type: 'video',
            fromVideoListing: true,
            data: {
                productId: props.videoLibrary.productUnderEdit,
                ignoreSave: props.videoLibrary.ignoreSave,
                options: ['camera', 'url']
            },
            style: {
                position: 'absolute',
                left: e.clientX,
                top: e.clientY - document.body.getBoundingClientRect().top
            },
            containerInfo: {
                element: e.currentTarget,
                pos: position
            }
        });
    }

    const videoKeys = Object.keys(props.videoLibrary.videos).sort((cur, next) => {
        const isCurNumeric = !isNaN(Number(cur));
        const isNextNumeric = !isNaN(Number(next));
        if (isCurNumeric && isNextNumeric) {
            return Number(next) - Number(cur);
        }
        if (!isCurNumeric && isNextNumeric) return -1;
        if (isCurNumeric && !isNextNumeric) return 1;
        return cur.localeCompare(next);
    });

    const noOfSlidersOpen = useMemo(() => historyHandler.getOpenSliders().length, [])

    return (
        <>
            <SliderWrapper
                header={{
                    heading: 'Select Video',
                    variant: 'secondary',
                    hasBorder: true,
                    // rightIcons: []
                    ...(props.isMobile || noOfSlidersOpen >= 1 ? {} : {
                        leftIcons: []
                    }),
                    className: scrolled ? `${style['scrolled']}` : ''
                }}
                onHidden={() => {
                    props.toggleLibrarySlider({ flag: false })
                }}
                updateScrollContRef={(scrollref) => {
                    setScrollEl(scrollref)
                }}
            >
                <div className={style['video-listing-container']}>
                    {videoKeys.length ? (videoKeys.map((cur, index) => {

                        let videoData = props.videoLibrary.videos[cur];
                        let status, tagVariant = '';
                        if(videoData.uploaded){
                            status = videoData.status == 'REVIEWED' ? 'LIVE' : (videoData.status == 'UNDER_REVIEW' ? 'VIDEO IN REVIEW' : 'error');
                            tagVariant = status == 'LIVE' ? 'success' : 'warning';
                        }

                        return (
                            <VideoRow
                                {...props}
                                videoData={videoData}
                                status={status}
                                tagVariant={tagVariant}
                                openPlayerSlider={(index) => openPlayerSlider(index)}
                                list={list}
                                key={index}
                                imgIndex={cur}
                                onVideoSelect={() => onVideoSelect(cur)}
                                setActiveEl={(index) => setActiveEl(index)}
                                id={cur}
                            />
                        )
                    })
                    ) : (
                            <div className={style['no-video-holder']}>
                                <img src='https://image1.jdomni.in/jdomni_email/graphic.svg' className={style['no-video-img']}></img>
                                <div className={style['heading']}>Select Video to Upload</div>
                                <div className={style['subtext']}>Upload a video file with .MP4 or .MOV format and file size under 100 MB (Recommended video quality of 360p or higher)</div>
                                <Button
                                    className={style['upload-btn']}
                                    size='lg'
                                    clickHandler={(e) => uploadVideo(e, 'bottom')}
                                >Upload Video</Button>
                            </div>
                        )}
                    {Object.keys(props.videoLibrary.videos).length ? <AnimateButton
                        style={{
                            boxShadow: '0 2px 5px 0.05px rgba(0,0,0,.02), 0 6px 10px 0 rgba(0,0,0,.05), 0 1px 18px 0 rgba(0,0,0,.1)'
                        }}
                        btnText='Upload Video'
                        iconClass={`icon-plus`}
                        onClick={uploadVideo}
                        btnWidth='9.75rem'
                        buttonClass={style['upload-btn']}
                        btnTextClass="animate-btn-text"
                        element={scrollEl}
                    /> : null}
                </div>
            </SliderWrapper>
            <FileSelector
                {...props}
				onChange={onChange}
                ref={fileSelector}
                forVideo={true}
			/>
            {openPlayer ? <VideoPlayerSlider
                {...playerData}
                isMobile={props.isMobile}
                playing={true}
                onHidden={() => {
                    togglePlayer(false)
                }}
                onVideoSelect={() => {
                    onVideoSelect(playerData.id);
                    setTimeout(() => {
                        window.history.back();
                    }, 300)
                }}
            /> : null}
        </>
    )
}

const VideoRowHtm = (props) => {
    const [hovered, setHovered] = useState(false);
    let videoData = props.videoData;

    const handleMouseIn = useCallback(() => !props.isMobile && setHovered(true), []);
    const handleMouseOut = useCallback(() => !props.isMobile && setHovered(false), []);

    const handleMoreMouseIn = useCallback(e => {
        e.stopPropagation();
        !props.isMobile && setHovered(false)
    }, []);

    const handleMoreMouseOut = useCallback(e => e.stopPropagation(), []);

    return (
        <div
            {...props.rippleHandler}
            className={`${style['video-holder']} ${hovered ? style['holder-hovered'] : ''}`}
            onClick={props.onVideoSelect}
            onMouseOver={handleMouseIn}
            onMouseLeave={handleMouseOut}
        >
            <div className={style['player-holder']} style={!videoData.uploaded ? {
                background: 'none'
            } : null}>
                <VideoPlayerWrapper
                    showThumbnail
                    thumbnailClass={style['thumbnail-holder']}
                    iconClass={style['play-icon']}
                    imgURL={videoData.imgUrl}
                    thumbnailURL={videoData.thumbnailURL}
                    imgIndex={props.id}
                    uploaded={videoData.uploaded}
                    sqSize={44}
                    source={videoData.source}
                    /* sqSize={130}
                    sqWidth={125}
                    sqHeight={72} */
                    onClick={event => {
                        event.stopPropagation();
                        props.openPlayerSlider(props.id);
                    }}
                />
                {props.status && props.status != 'LIVE' ? (<div className={`${style['status-dot']} ${props.tagVariant}`}></div>) : null}
            </div>
            <div className={style['video-info-holder']}>
                <div className={style['video-info']}>
                    <div className={style['name']}>{videoData.videoName}</div>
                    {props.status ? <Tag variant={props.tagVariant}><span className={style['video-tag']}>{props.status}</span></Tag> : null}
                    {props.status == 'error' ? <>
                        <div className={style['error']}>
                            The video could not be processed
                                        </div>
                        <div className={style['helper-text']}>
                            Please delete it and upload it again
                                        </div>
                    </> : null}
                    {!props.uploaded && props.videoUpload.videos[props.id] ? (
                        <div className={style['progress-text']}>{props.videoUpload.videos[props.id].progress > 50 ? 'Processing' : 'Uploading'} Video {props.videoUpload.videos[props.id].progress}%</div>
                    ) : null}
                </div>
                <div
                    className={style['more-menu-holder']}
                    onMouseOver={handleMoreMouseIn}
                    onMouseLeave={handleMoreMouseOut}
                >
                    <MoreMenu
                        onToggle={() => props.setActiveEl(props.id)}
                        list={props.list}
                        menuClass={style['menu-list']}
                        parentClass={style['icon-holder']}
                    />
                </div>
            </div>
            <div className={style['bottom-border']} />
            {props.renderRipple && props.renderRipple()}
        </div>
    )
}

const VideoRow = withRipple(VideoRowHtm);

const mapStateToProps = (state, props) => {
    return {
        videoLibrary: state.videoLibrary,
        session: state.session,
        videoUpload: state.videoupload,
        isMobile: state.library.deviceData.isMobile
    };
};

export default connect(mapStateToProps, {
    getVideoLibraryData,
    toggleLibrarySlider,
    selectVideo,
    deleteVideo,
    getListingData,
    updateProductMedia,
    toggleUploadOptions,
    showToast: toastMessageActions.showMessage,
    deleteProductVideo
})(VideoListing);
